<template>
    <div class="container">
    <!-- Grid Layout for Items -->
        <div class="columns is-mobile is-multiline">
        <!-- Loop through the items to create the grid -->
            <div
                class="column is-one-third-mobile is-one-quarter-tablet"
                v-for="(item, index) in items"
                :key="index">
            <!-- Card for each Item -->
                <div class="card">
                    <div class="card-image">
                        <figure class="image is-2by2">
                        <img :src="require(`@/assets/images/${item.image}`)" :alt="item.name" />
                        </figure>
                    </div>
                    <div class="card-content has-text-centered custom-card-content">
                        <!-- Like and Dislike Buttons -->
                        <button
                            class="button is-success is-small"
                            :class="{ 'is-light': item.selected === 'dislike' || item.selected === null }"
                            :disabled="item.selected === 'like'"
                            @click="handleLike(index)"
                            >
                            ✅
                        </button>
                        <button
                            class="button is-danger is-small"
                            :class="{ 'is-light': item.selected === 'like' || item.selected === null }"
                            :disabled="item.selected === 'dislike'"
                            @click="handleDislike(index)"
                            >
                            ⛔
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-if="!!error" class="notification is-danger is-light">
        <p>{{ error }}</p>
    </div>
    <div class="align-center block">
        <button class="button is-info is-large is-rounded" :class="[isLoading ? 'is-loading' : '']" @click="submitSurvey">Submit</button>
    </div>
</template>

<script>
export default {
    emits: ['closeSurvey'],
    props: {
        id: {
            type: String,
            required: true
        },
        beneficiaryID: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            items: [
                { name: "breadbrown", image: "breadbrown.jpg", like: 0, dislike: 0, selected: null },
                { name: "breadwhite", image: "bread.jpg", like: 0, dislike: 0, selected: null },
                { name: "spreads", image: "spreads.jpg", like: 0, dislike: 0, selected: null },
                { name: "cannedfood", image: "canned.jpg", like: 0, dislike: 0, selected: null },
                { name: "crackers", image: "crackers.jpg", like: 0, dislike: 0, selected: null },
                { name: "coffeetea", image: "coffeetea.jpg", like: 0, dislike: 0, selected: null },
                { name: "fruits", image: "fruits.jpg", like: 0, dislike: 0, selected: null },
                { name: "fruitsexotic", image: "fruitsexotic.jpg", like: 0, dislike: 0, selected: null },
                { name: "eggs", image: "eggs.jpg", like: 0, dislike: 0, selected: null },
                { name: "leafies", image: "leafies.jpg", like: 0, dislike: 0, selected: null },
                { name: "roots", image: "roots.jpg", like: 0, dislike: 0, selected: null },
                { name: "garliconion", image: "garliconion.jpg", like: 0, dislike: 0, selected: null },
                { name: "tofu", image: "tofu.jpg", like: 0, dislike: 0, selected: null },
                { name: "staples", image: "staples.jpg", like: 0, dislike: 0, selected: null },
                { name: "tooth", image: "tooth.jpg", like: 0, dislike: 0, selected: null },
                { name: "toilet", image: "toilet.jpg", like: 0, dislike: 0, selected: null },
                { name: "cleaning", image: "cleaning.jpg", like: 0, dislike: 0, selected: null },
            ],
            isLoading: false,
            error: null
        };
    },
    methods: {
        handleLike(index) {
            // Reset dislike if like is selected
            if (this.items[index].selected !== 'like') {
                this.items[index].dislike = 0; // Reset dislike count
                this.items[index].like++; // Increment like count
                this.items[index].selected = 'like'; // Set selected state to 'like'
            } else {
                // Toggle off if already liked
                this.items[index].like = 0;
                this.items[index].selected = null; // Deselect
            }
            console.log(`Updated: ${this.items[index].name} - Likes: ${this.items[index].like}, Dislikes: ${this.items[index].dislike}`);
        },
        handleDislike(index) {
             // Reset like if dislike is selected
            if (this.items[index].selected !== 'dislike') {
                this.items[index].like = 0; // Reset like count
                this.items[index].dislike++; // Increment dislike count
                this.items[index].selected = 'dislike'; // Set selected state to 'dislike'
            } else {
                // Toggle off if already disliked
                this.items[index].dislike = 0;
                this.items[index].selected = null; // Deselect
            }
            console.log(`Updated: ${this.items[index].name} - Likes: ${this.items[index].like}, Dislikes: ${this.items[index].dislike}`);
        },
        async submitSurvey() {
            this.isLoading = true;
            this.error = null;
            const itemLikesArray = this.items.map(item => ({ name: item.name, like: item.like, dislike: item.dislike }));
            try {
                    await this.$store.dispatch('surveys/submitSurvey', {
                        surveyID: this.id,
                        beneficiaryID: this.beneficiaryID, 
                        itemLikesArray: itemLikesArray,
                    });
                    this.isSuccess = true;
                    this.closeSurvey();

                } catch (error) {
                    this.error = error.message;
                }
            this.isLoading = false;
        },
        closeSurvey() {
            this.$emit('closeSurvey');
        }
    },
};
</script>

<style scoped>
td {
    text-align: center; /* Center horizontally */
    vertical-align: middle; /* Center vertically */
    border: 1px solid black;
}
/* Customize the grid and button styles as needed */
.card {
  margin-bottom: 1rem;
}
</style>

<style scoped>
/* Custom CSS to reduce padding for card-content */
.custom-card-content {
  padding: 5px !important; /* Use '!important' to override Bulma's default padding */
}
</style>